import { NgPlural, NgPluralCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { WhiteLabelService } from '@flexyoo/common';
import { UserNotificationsService } from '@flexyoo/shared/services';
import { TranslateModule } from '@ngx-translate/core';
import { HrEmployeeListFiltersService } from '../../hr-employee-list/hr-employee-list-filters.service';
import { HrCartViewFiltersService } from '../../hr-transactions/services/hr-cart-view-filters.service';
import { HrTransactionsFiltersService } from '../../hr-transactions/services/hr-transactions-filters.service';
import { IHrAlerts } from '../models/hr-alerts.interface';

@Component({
  selector: 'app-hr-alerts-block',
  templateUrl: './hr-alerts-block.component.html',
  styleUrl: './hr-alerts-block.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgPlural, TranslateModule, NgPluralCase, MatIcon, MatDivider],
})
export class HrAlertsBlockComponent {
  @Input() public set hrAlerts(hrAlerts: IHrAlerts) {
    this.alertsWithIcons = [];
    this.mobilityBudgetAlertsWithIcons = [];

    if (hrAlerts?.lmbBudgetActivationFailedCount) {
      this.mobilityBudgetAlertsWithIcons.push({
        title: 'lmbBudgetActivationFailedCount',
        count: hrAlerts.lmbBudgetActivationFailedCount,
        icon: 'fo-sync',
      });
    }

    if (hrAlerts?.pendingVerificationUserAgreementCount) {
      this.alertsWithIcons.push({
        title: 'pendingVerificationUserAgreementCount',
        count: hrAlerts.pendingVerificationUserAgreementCount,
        icon: 'fo-doc',
      });
    }
    if (hrAlerts?.pendingVerificationBenefitAddendumCount) {
      this.alertsWithIcons.push({
        title: 'pendingVerificationBenefitAddendumCount',
        count: hrAlerts.pendingVerificationBenefitAddendumCount,
        icon: 'fo-doc',
      });
    }
    if (hrAlerts?.awaitingDeliveryEmployeeBenefitCount) {
      this.alertsWithIcons.push({
        title: 'awaitingDeliveryEmployeeBenefitCount',
        count: hrAlerts.awaitingDeliveryEmployeeBenefitCount,
        icon: 'fo-benefit',
      });
    }
    if (hrAlerts?.cashBenefitsOutsidePeriodCount) {
      this.alertsWithIcons.push({
        title: 'cashBenefitsOutsidePeriodCount',
        count: hrAlerts.cashBenefitsOutsidePeriodCount,
        icon: 'fo-period',
      });
    }
    if (hrAlerts?.externalSupplierConfirmationErrorsCount) {
      this.alertsWithIcons.push({
        title: 'externalSupplierConfirmationErrorsCount',
        count: hrAlerts.externalSupplierConfirmationErrorsCount,
        icon: 'fo-benefit',
      });
    }
    if (hrAlerts?.benefitsToEndWithinPeriodCount) {
      this.alertsWithIcons.push({
        title: 'benefitsToEndWithinPeriodCount',
        count: hrAlerts.benefitsToEndWithinPeriodCount,
        icon: 'fo-doc',
      });
    }
    if (hrAlerts?.awaitingResidualValuePaymentBenefitsCount) {
      this.alertsWithIcons.push({
        title: 'awaitingResidualValuePaymentBenefitsCount',
        count: hrAlerts.awaitingResidualValuePaymentBenefitsCount,
        icon: 'fo-benefit',
      });
    }
    if (hrAlerts?.cartsPendingEmployeeApprovalCount) {
      this.alertsWithIcons.push({
        title: 'cartsPendingEmployeeApprovalCount',
        count: hrAlerts.cartsPendingEmployeeApprovalCount,
        icon: 'fo-benefit',
      });
    }
    if (hrAlerts?.cartsPendingHrApprovalCount) {
      this.alertsWithIcons.push({
        title: 'cartsPendingHrApprovalCount',
        count: hrAlerts.cartsPendingHrApprovalCount,
        icon: 'fo-benefit',
      });
    }
    if (hrAlerts?.cartsWithExternalBenefitsExpiringCount) {
      this.alertsWithIcons.push({
        title: 'cartsWithExternalBenefitsExpiringCount',
        count: hrAlerts.cartsWithExternalBenefitsExpiringCount,
        icon: 'fo-benefit',
      });
    }
    if (hrAlerts?.cartsAwaitingExpirationCount) {
      this.alertsWithIcons.push({
        title: 'cartsAwaitingExpirationCount',
        count: hrAlerts.cartsAwaitingExpirationCount,
        icon: 'fo-benefit',
      });
    }
    if (hrAlerts?.cartAddendumsPendingHrApprovalCount) {
      this.alertsWithIcons.push({
        title: 'cartAddendumsPendingHrApprovalCount',
        count: hrAlerts.cartAddendumsPendingHrApprovalCount,
        icon: 'fo-benefit',
      });
    }
    if (hrAlerts?.cartsPendingHrRejectionCount) {
      this.alertsWithIcons.push({
        title: 'cartsPendingHrRejectionCount',
        count: hrAlerts.cartsPendingHrRejectionCount,
        icon: 'fo-benefit',
      });
    }
  }

  protected readonly wls = inject(WhiteLabelService);
  private readonly hrTransactionsFiltersService = inject(HrTransactionsFiltersService);
  private readonly hrCartViewFiltersService = inject(HrCartViewFiltersService);
  private readonly hrEmployeeListFiltersService = inject(HrEmployeeListFiltersService);
  private readonly userNotificationsService = inject(UserNotificationsService);

  protected alertsWithIcons: { title: keyof IHrAlerts; count: number; icon: string }[] = [];
  protected mobilityBudgetAlertsWithIcons: {
    title: keyof IHrAlerts;
    count: number;
    icon: string;
  }[] = [];

  protected navigateByNotificationType(notificationType: keyof IHrAlerts) {
    this.userNotificationsService.proceedToHrAlertType(
      notificationType,
      this.hrEmployeeListFiltersService,
      this.hrTransactionsFiltersService,
      this.hrCartViewFiltersService
    );
  }
}
